import { useEffect } from 'react';
import {
  GET_ORGANISATION,
  GET_ORGANISATIONS,
  setDefaultHeader,
} from '@/studbook/graphql/queries';
import {
  GetOptInOrgsResponse,
  GetOrganisationResponse,
} from '@/studbook/graphql/results';
import { useQuery } from '@apollo/client';
import useImageFromEntity from './useImageFromEntity';
import { DocumentImageSize } from '@/lib/types';
import { DocumentTypeCode } from '@/studbook/constants';

export function useOrganisationByOrgName(orgName: string) {
  const { data } = useQuery<GetOptInOrgsResponse>(GET_ORGANISATIONS);

  // Only search for organization if orgName is provided and not empty
  const currentOrg =
    orgName && typeof orgName === 'string' && orgName.trim()
      ? data?.optInOrganisations.find(
          (o) => o.name.toLowerCase() === orgName.toLowerCase(),
        )
      : undefined;

  const orgId = currentOrg?.orgId ?? '';

  const {
    data: orgResponse,
    error: errorOrg,
    loading: loadingOrg,
  } = useQuery<GetOrganisationResponse>(GET_ORGANISATION, {
    skip: !orgId,
    variables: {
      orgId: Number(orgId),
    },
    context: {
      headers: {
        ...setDefaultHeader(orgId),
      },
    },
  });

  const { imgUrl: orgImgUrl, isLoadingImg } = useImageFromEntity(
    orgResponse?.organisation.organisationEntityId ?? '',
    orgId!,
    DocumentImageSize.xl,
    DocumentTypeCode.Logo,
  );

  useEffect(() => {
    if (errorOrg) {
      console.error('Error fetching organisation:', errorOrg);
    }
  }, [errorOrg]);

  return {
    orgId,
    orgName: currentOrg?.name ?? '',
    orgImgUrl,
    description: currentOrg?.description ?? '',
    loading: loadingOrg || isLoadingImg,
  };
}
